<script setup>
import {computed} from 'vue'

const props = defineProps({
  menuItems: {
    type: Array,
    required: true
  },
  activeItem: {
    type: Object,
    default: () => ({})
  },
  opened: {
    type: Boolean,
    default: false
  },
})

const emit = defineEmits(['setMenuKey'])

// Computed properties
const isMenuVisible = computed(() => props.opened)

// Event handlers
const handleMenuLeave = () => {
  emit('setMenuKey', {key: -1})
}

const handleItemHover = (key, link) => {
  emit('setMenuKey', {key, link})
}

// Helper functions
const isActiveItem = (item) => {
  return item.link === props.activeItem.link
}

const hasChildren = (item) => {
  return item.children && item.children.length > 0
}

const getItemStyles = (item) => {
  const styles = []
  if (item.color) {
    styles.push(`color: ${item.color}`)
  }
  if (item.bold === '1') {
    styles.push('font-weight: 800')
  }
  return styles.join('; ')
}

const isSubMenuVisible = (key) => {
  return key === props.activeItem.key
}

const getSubMenuClasses = (key) => {
  return ['subLevelMenu', `subLevelMenu--${key}`]
}
</script>

<template>
  <div v-if="isMenuVisible"
       ref="desktopMenu"
       class="desktopMenu"
       @mouseleave="handleMenuLeave"
  >
    <!-- Main Menu Items -->
    <div class="leftFixBlock">
      <div
          v-for="(item, key) in menuItems"
          :key="`menu-item-${key}`"
          class="rootItem"
          :class="{
          active: isActiveItem(item),
          hasChild: hasChildren(item)
        }"
          @mouseenter="handleItemHover(key, item.link)"
      >
        <span
            v-if="item.icon"
            v-html="item.icon"
        />

        <a
            :href="item.link"
            :style="getItemStyles(item)"
        >
          <div
              v-if="item.img"
              class="imgWraper"
              v-html="item.img"
          />
          {{ item.text }}
        </a>
      </div>
    </div>

    <!-- Sub Level Menus -->
    <div
        v-for="(item, key) in menuItems"
        :key="`submenu-${key}`"
        :class="getSubMenuClasses(key)"
        v-show="isSubMenuVisible(key)"
    >
      <div class="subLevelMenu__wrapper">
        <div
            v-for="(block, blockIndex) in item.children"
            :key="`block-${blockIndex}`"
            class="subLevelMenu__block"
        >
          <!-- Block Header Item -->
          <div class="subItem">
            <a :href="block.link">
              <div
                  v-if="block.img"
                  class="imgWraper"
                  v-html="block.img"
              />
              {{ block.text }}
            </a>
          </div>

          <!-- Block Child Items -->
          <div
              v-for="(childItem, childIndex) in block.children"
              :key="`child-${childIndex}`"
              class="subItem child"
          >
            <a
                :href="childItem.link"
                style="padding-left: 12px"
            >
              <div
                  v-if="childItem.img"
                  class="imgWraper"
                  v-html="childItem.img"
              />
              {{ childItem.text }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.desktopMenu {
  position: absolute;
  padding: 0px;
  left: 0;
  top: 100%;
  z-index: 2147483646;
  display: flex;
  width: 100%;
}

.desktopMenu .leftFixBlock {
  background: #f7f7f7;
}

.desktopMenu .rootItem {
  padding: 10px;
  padding-bottom: 6px;
  padding-top: 6px;
  position: relative;
}

.desktopMenu .rootItem.active {
  background: #fff;
}

.desktopMenu a {
  text-decoration: none !important;
}

.desktopMenu .rootItem > a:hover {
  color: inherit;
}

.desktopMenu .rootItem.hasChild {
  padding-right: 25px;
}

.desktopMenu .rootItem.hasChild::after {
  content: "";
  display: inline-block;
  position: absolute;
  right: 10px;
  width: 10px;
  height: 10px;
  top: 50%;
  margin-top: -5px;
  border-top: 2px solid #7b7c7e;
  border-right: 2px solid #7b7c7e;
  transform: rotate(45deg);
}

.subLevelMenu {
  background: #fff;
  border-bottom: solid 1px #f7f7f7;
  border-right: solid 1px #f7f7f7;
  max-width: calc(100% - 220px);
  position: absolute;
  left: 280px;
  min-height: 100%;
}

.subLevelMenu .subItem {
  padding-bottom: 5px;
  padding-top: 5px;
  line-height: 14px;
}

.subLevelMenu .subItem a:hover {
  color: #000;
}
</style>